import {$clientApi} from "../http";
import {ISiteContent} from "../models/SiteContent";

class SiteContentServiceClass {

    async getSiteContent(language: string) {
        return $clientApi.get<ISiteContent>(`api/website-integration?language=${language}`)
    }

}

export const SiteContentService = new SiteContentServiceClass();